module.exports = __webpack_public_path__ + "static/media/5.Clock chime.b767979a.mp3";